import { components, type GroupBase, type MultiValueRemoveProps } from 'react-select';
import { msg } from '@gonfalon/messages/msg';

function plainText(value: unknown) {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean'
    ? String(value) || undefined
    : undefined;
}

export function AccessibleMultiValueRemove<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MultiValueRemoveProps<Option, IsMulti, Group> & { ariaLabel?: string },
) {
  const { ariaLabel, ...removeProps } = props;
  const { data, selectProps, innerProps } = removeProps;
  const label = plainText(selectProps.getOptionLabel(data)) ?? plainText(selectProps.getOptionValue(data));

  return (
    <components.MultiValueRemove
      {...removeProps}
      innerProps={{
        ...innerProps,
        'aria-label':
          ariaLabel ??
          (label ? msg('ui.select.removeOptionLabel', { option: label }) : msg('ui.select.removeOptionFallbackLabel')),
      }}
    />
  );
}
